// useFetch.js
import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { getAPI } from "../api/api";

export const useFetch = (url, options, onSuccess) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      if (url) {
        const result = await getAPI(url, options);
        setData(result.data);
        if (onSuccess) {
          onSuccess(result.data);
        }
      }
    } catch (err) {
      setError(err);
      const message =
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        err.toString();
      toast.error(message);
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData, setData };
};
